const translates = {
	en: {
		blockTitle: 'Favorite',
	},
	ru: {
		blockTitle: 'Избранное',
	}
};
export default translates;